import axios from "axios";
import { API_URL } from "../config";

export default class {
    static getAll = async (token) => {
        let result = { data: null, error: null };
        await axios.get(`${API_URL}/services/all-admin`, {
            headers: { alshorja_auth: token }
        }).then(res => {
            result.data = res.data;
        }).catch(err => {
            result.error = err.response ? err.response.data : (err.message || "Server Error");
        });
        return result;
    }

    static updateStatus = async (token, id, verified) => {
        let result = { data: null, error: null };
        await axios.post(`${API_URL}/services/update-status`, { id, verified }, {
            headers: { alshorja_auth: token }
        }).then(res => {
            result.data = res.data;
        }).catch(err => {
            result.error = err.response ? err.response.data : (err.message || "Server Error");
        });
        return result;
    }

    static delete = async (token, id) => {
        let result = { data: null, error: null };
        await axios.delete(`${API_URL}/services/${id}`, {
            headers: { alshorja_auth: token }
        }).then(res => {
            result.data = res.data;
        }).catch(err => {
            result.error = err.response ? err.response.data : (err.message || "Server Error");
        });
        return result;
    }
}
